import classnames from 'classnames';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@components/Button';
import { PrintIcon } from '@components/Icons';

import styles from './Title.module.scss';

const languageNamespace = 'common';

interface TitleProps {
  title?: string | ReactNode;
  titleAlignment?: 'left' | 'center' | 'right';
  titleWeight?: 'normal' | 'bold' | 'bolder';
  titleColor?: 'default' | 'gray' | 'darkGray';
  fontSize?: 'small' | 'medium' | 'large' | 'larger' | 'warning';
  closeIcon?: boolean;
  onClick?: () => void;
  horizontalRule?: boolean;
  className?: string;
  onPrint?: () => void;
}

export const Title = ({
  title,
  titleAlignment = 'center',
  titleWeight = 'bold',
  titleColor = 'default',
  closeIcon = false,
  fontSize = 'medium',
  onClick,
  horizontalRule = false,
  className,
  onPrint,
}: TitleProps) => {
  const { t } = useTranslation(languageNamespace);

  if (!title) {
    return null;
  }
  const renderTitle = (value: ReactNode | string) => {
    if (typeof value === 'string') {
      return <span>{value}</span>;
    }
    return value;
  };
  return (
    <>
      <div className={classnames(styles.titleAndIconContainer, className)}>
        <div
          className={`${styles.title} ${styles[titleAlignment]} ${styles[titleWeight]} ${styles[titleColor]} ${styles[fontSize]}`}>
          {renderTitle(title)}
        </div>
        {onPrint && (
          <Button
            appearance="text"
            text={t('print')}
            className={styles.print}
            icon={() => <PrintIcon size={34.1} />}
            onClick={onPrint}
          />
        )}
        {closeIcon && (
          <button aria-label="Close" onClick={onClick} className={styles.closeIconButton}>
            <span className={styles.closeIcon}>×</span>
          </button>
        )}
      </div>
      {horizontalRule && <div className={styles.horizontalRule}></div>}
    </>
  );
};

export default Title;
